// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-hierarchy {
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  gap: 1vh;
}
.page-hierarchy__description {
  color: #5B5656;
  font-size: 0.85rem;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/page-hierarchy/page-hierarchy.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACJ;AACI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AACR","sourcesContent":[".page-hierarchy{\n    font-size: 1rem;\n    font-weight: bold;\n    display: flex;\n    flex-direction: column;\n    gap: 1vh;\n\n    &__description{\n        color: #5B5656;\n        font-size: 0.85rem;\n        font-weight: 500;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
